const SHIPPING_COST_ROUTE_NAMES = new Set([
  'shipping-cost',
  'shipping-profile-edit',
  'shipping-cost-zone-new',
  'shipping-cost-zone-edit',
  'shipping-rule-new',
  'shipping-rule-edit',
  'settings-shipping',
  'settings-shipping-profile-edit',
  'settings-shipping-zone-new',
  'settings-shipping-zone-edit',
  'settings-shipping-rule-new',
  'settings-shipping-rule-edit',
])

type MatchedRoute = { name?: unknown; path: string }

const isNamedShippingCostRoute = (name: unknown): boolean =>
  typeof name === 'string' && SHIPPING_COST_ROUTE_NAMES.has(name)

const isShippingCostPath = (path: string): boolean =>
  path.includes('/cost-settings/shipping-cost') ||
  path.includes('/settings/shipping') ||
  /\/shipping-cost\/profile\/[^/]+(\/edit|\/rule\/)/.test(path) ||
  /\/settings\/shipping\/profile\/[^/]+(\/edit|\/rule\/)/.test(path)

export function isShippingCostNavigationRoute(name: unknown, path = '', matched: MatchedRoute[] = []): boolean {
  if (isNamedShippingCostRoute(name)) {
    return true
  }

  if (isShippingCostPath(path)) {
    return true
  }

  return matched.some((record) => isNamedShippingCostRoute(record.name) || isShippingCostPath(record.path))
}

export function isSettingsShippingBranch(path: string): boolean {
  return path.includes('/settings/shipping')
}
